import React, { forwardRef } from "react";
import { classNames } from "../utils";

interface IInputFieldProps
  extends React.InputHTMLAttributes<HTMLTextAreaElement> {
  handleChange?: ({ target }: React.ChangeEvent<HTMLTextAreaElement>) => void;
  handleBlur?: ({ target }: React.ChangeEvent<HTMLTextAreaElement>) => void;
  type?: string;
  name: string;
  label?: string;
  classes?: string;
  labelClassName?: string;
}

const TextAreaField = forwardRef<HTMLTextAreaElement, IInputFieldProps>(
  (
    {
      handleChange,
      type,
      name,
      label,
      classes,
      handleBlur,
      labelClassName,
      ...rest
    },
    ref
  ) => {
    return (
      <div className={classes ?? "w-96"}>
        {label && (
          <label
            htmlFor={name}
            className={classNames(
              "block text-sm font-medium text-gray-600 mb-2",
              labelClassName ?? ""
            )}
          >
            {label}
          </label>
        )}
        <textarea
          disabled={rest.disabled}
          id={name}
          onChange={handleChange}
          onBlur={handleBlur}
          name={name}
          {...rest}
          className={classNames(
            "border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5",
            rest.className ?? ""
          )}
          ref={ref}
        />
      </div>
    );
  }
);
export default TextAreaField;
